// extracted by mini-css-extract-plugin
export default {"textWrapper":"style_textWrapper__zM1yn","linkText":"style_linkText__krfh3"};